import { Action } from 'redux';
import { delay } from 'redux-saga';
import { cancel, fork, put, take } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';
import * as actions from './actions';

function* handleSearch(
  action: Action & {
    payload: {
      type: 'event' | 'country';
      text: string;
    };
  }
) {
  yield delay(200);
  yield put(actions.search(action.payload));
}

function* watchSearchRequests() {
  let task;
  while (true) {
    const action = yield take(getType(actions.searchRequest));
    if (task) {
      yield cancel(task);
    }
    task = yield fork(handleSearch, action);
  }
}

export default function*() {
  yield watchSearchRequests();
}



// WEBPACK FOOTER //
// ./src/store/modules/events/saga.ts